import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';


import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService } from './../../../../providers';

@Injectable()
export class GridDataService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService) { }

  fetchGridData(dataurl) {

    return this.httpClientService.get(dataurl)
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));

  }


  fetchGridFilterData(dataurl, gridFetch: any) {

  //  console.log(gridFetch);

    return this.httpClientService.get(dataurl)
      .pipe(
       map((test: HttpResponse<any>) => test.body)
      ,catchError( this.handleError ));
  }

  fetchGridServiceData(requestUrl, requestBody) {
    let headers = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
    return this.httpClientService.put(requestUrl, requestBody, headers)
      .pipe(
       map((user: HttpResponse<any>) => user.body)
      ,catchError( this.handleError ));
  }


  handleError = (error) => {
    return throwError(error);
  };

}
